const defaultErrorMessage =
  "There was a problem processing your request. Please try again later.";

export const handleAsyncError = (msg = defaultErrorMessage) => alert(msg);
